import EditableItemFooter from './EditableItemFooter'
import ReadOnlyItemFooter from './ReadOnlyItemFooter'
import RestoreCartModalFooter from '../../../Common/RestoreCartModalFooter'

import { useTrip } from 'tripPlanner/hooks/api/trip'
import useCanEditTrip from 'tripPlanner/hooks/useCanEditTrip'
import type { TripItem } from 'tripPlanner/types/tripItem'
import { isLeBookmark } from 'tripPlanner/utils'
import { isBookableItem } from 'tripPlanner/utils/bookmark/restoreCart'

interface Props {
  item: TripItem
}

export default function DefaultSummaryModalFooter({ item }: Props) {
  const { data: trip } = useTrip({ tripId: item.tripId })
  const canEdit = useCanEditTrip()

  if (!trip) {
    return null
  }

  const isBookable = isLeBookmark(item) && isBookableItem(item)

  if (!canEdit || item.isSuggested) {
    return <ReadOnlyItemFooter item={item} />
  } else if (isBookable) {
    return <RestoreCartModalFooter item={item} />
  } else {
    return <EditableItemFooter item={item} />
  }
}
